import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import WareIMG from "../../assets/WareHouseImg.jpg";

const WareHouse = () => {
  return (
    <>
      <Helmet>
        <title>Warehouse & Distribution | Trans World Shipping</title>
        <meta
          name="description"
          content="Explore our comprehensive warehousing solutions with Trans World Shipping."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/services/warehouse-distribution"
        />
      </Helmet>

      <TheWareHouse>
        <div className="warehouse-hero">
          <img src={WareIMG} alt="Warehouse and Distribution Center" />
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Warehousing & Distribution</h1>
            <p>
              Strategically positioned distribution centers with real-time
              visibility
            </p>
          </div>
        </div>

        <div className="warehouse-container">
          <div className="intro-section">
            <p>
              Regionally based and located, our strategically positioned
              distribution centers carry our customers inventory and provide
              real time visibility to their products.
            </p>
          </div>

          <div className="process-section">
            <p>
              Our integrated process helps to synchronize the flow of materials
              through our customers supply chain.
            </p>
          </div>

          <div className="benefits-section">
            <p>
              Benefits include streamlined inventory as well as reduced
              logistics and shipping cost.
            </p>
          </div>

          <div className="services-section">
            <h3>In addition to basics, we also offer:</h3>
            <div className="services-grid">
              <div className="service-item">Origin vendor consolidation</div>
              <div className="service-item">QC</div>
              <div className="service-item">VMI – Vendor managed inventory</div>
              <div className="service-item">Transloading | Back to back</div>
              <div className="service-item">De-Consolidation</div>
              <div className="service-item">Pick + pack operations</div>
              <div className="service-item">Quality check and control</div>
              <div className="service-item">Kitting | Reversed logistics</div>
              <div className="service-item">Release and distribution</div>
              <div className="service-item">To multiply consignees</div>
              <div className="service-item">Assembly</div>
            </div>
          </div>

          <div className="improvement-section">
            <p>
              We are constantly improving and expanding our capabilities to
              provide our customers with an operational system that works
              seamlessly and cost-effectively, supporting their supply chain
              management for the benefit of their customers.
            </p>
          </div>
        </div>
      </TheWareHouse>
    </>
  );
};

const TheWareHouse = styled.div`
  width: 100%;
  background: #ffffff;

  .warehouse-hero {
    position: relative;
    width: 100%;
    height: 45vh;
    min-height: 350px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(11, 30, 51, 0.8) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .warehouse-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .intro-section {
    text-align: center;
    margin-bottom: 2rem;

    p {
      font-size: 1.2rem;
      color: #0b1e33;
      line-height: 1.7;
      font-weight: 500;
    }
  }

  .process-section {
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;

    p {
      color: white;
      font-size: 1.1rem;
      line-height: 1.7;
    }
  }

  .benefits-section {
    background: #f8f9fa;
    padding: 1.5rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 2rem;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1rem;
      color: #d4af37;
      font-weight: 600;
    }
  }

  .services-section {
    margin-bottom: 2rem;

    h3 {
      font-size: 1.3rem;
      color: #0b1e33;
      margin-bottom: 1.5rem;
      text-align: center;
      font-weight: 600;
    }

    .services-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 1rem;

      .service-item {
        background: #f8f9fa;
        padding: 0.9rem;
        border-radius: 8px;
        font-size: 0.9rem;
        color: #4a5568;
        text-align: center;
        border: 1px solid #e2e8f0;
        transition: all 0.3s ease;

        &:hover {
          border-color: #d4af37;
          transform: translateY(-2px);
          background: white;
        }
      }
    }
  }

  .improvement-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.7;
    }
  }

  @media screen and (max-width: 1024px) {
    .services-section .services-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media screen and (max-width: 900px) {
    .warehouse-hero {
      height: 40vh;
      min-height: 300px;

      .hero-content h1 {
        font-size: 2.5rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .warehouse-container {
      padding: 3rem 1.5rem;
    }

    .intro-section p {
      font-size: 1.1rem;
    }
  }

  @media screen and (max-width: 768px) {
    .warehouse-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 2rem;
      }
    }

    .warehouse-container {
      padding: 2rem 1rem;
    }

    .intro-section p {
      font-size: 1rem;
    }

    .services-section .services-grid {
      grid-template-columns: 1fr;
      gap: 0.75rem;
    }

    .services-section h3 {
      font-size: 1.1rem;
    }
  }

  @media screen and (max-width: 600px) {
    .warehouse-hero .hero-content h1 {
      font-size: 1.6rem;
    }

    .process-section p,
    .improvement-section p {
      font-size: 0.95rem;
    }
  }

  @media screen and (max-width: 480px) {
    .warehouse-hero .hero-content h1 {
      font-size: 1.3rem;
    }

    .warehouse-hero .hero-content p {
      font-size: 0.9rem;
    }

    .services-section .service-item {
      font-size: 0.85rem;
      padding: 0.7rem;
    }
  }
`;

export default WareHouse;
